<template>
  <HeaderView />
  <div class="min-h-screen bg-gray-700">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <!-- Subscription Terms / EULA Section -->
      <div class="bg-white p-6 sm:p-8 shadow-sm rounded-lg">
        <h1 class="text-2xl font-bold text-gray-900 mb-8 border-b pb-4">Terms of Use (End User License Agreement)</h1>

        <div class="space-y-8 text-gray-700">
          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">1. Subscription Terms</h2>
            <p class="leading-relaxed">
              The App offers auto-renewable subscriptions. By purchasing a subscription, you agree that:
            </p>
            <ul class="list-disc list-inside space-y-2">
              <li>Payment will be charged to your Apple ID account at the confirmation of purchase.</li>
              <li>The subscription automatically renews unless auto-renew is turned off at least 24 hours before the end of the current period.</li>
              <li>Your account will be charged for renewal within 24 hours prior to the end of the current period.</li>
              <li>You can manage or cancel your subscriptions in your Apple ID account settings after purchase.</li>
            </ul>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">2. License</h2>
            <p class="leading-relaxed">
              We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial purposes in accordance with these terms.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">3. User Data</h2>
            <p class="leading-relaxed">
              We may collect limited technical data to improve the App’s functionality. Please review our Privacy Policy for more information.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">4. Restrictions</h2>
            <p class="leading-relaxed">
              You may not:
            </p>
            <ul class="list-disc list-inside space-y-2">
              <li>Copy, modify, or distribute the App.</li>
              <li>Reverse engineer or attempt to extract the source code.</li>
              <li>Use the App for any illegal purposes.</li>
            </ul>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">5. Termination</h2>
            <p class="leading-relaxed">
              We reserve the right to terminate or suspend your access if you violate these Terms.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">6. Limitation of Liability</h2>
            <p class="leading-relaxed">
              The App is provided “as is” without warranties of any kind. We shall not be liable for any damages arising from your use of the App.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">7. Contact Information</h2>
            <p class="leading-relaxed">
              If you have questions about these Terms, contact us at:
              <a href="mailto:cs@usmanheart.org" class="text-blue-600 hover:underline">cs@usmanheart.org</a>
            </p>
            <p class="leading-relaxed mt-2">
              Company: USMANHEART OÜ
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">8. Governing Law</h2>
            <p class="leading-relaxed">
              These Terms shall be governed by the laws of the European Union, without regard to conflict of law principles.
            </p>
          </section>

          <div class="mt-10 pt-6 border-t border-gray-200">
            <p class="text-sm text-gray-500">
              Effective: December 10, 2025 | Version: 1.0
            </p>
          </div>
        </div>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";

export default {
  name: 'SellingPolicy',
  components: { HeaderView, FooterView }
}
</script>
